module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-col page"
  }, [_c('div', {
    staticClass: "flex-col group_3"
  }, [_c('div', {
    staticClass: "section_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-col section_2"
  }, [_c('div', {
    staticClass: "justify-between group_4"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_vm._v("兑换码可兑换相应 会员/卡包")]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('span', {
    staticClass: "text_4",
    on: {
      "click": _vm.goCouponList
    }
  }, [_vm._v("我的卡劵")]), _vm._v(" "), _c('img', {
    staticClass: "image_4",
    attrs: {
      "src": "https://imgpub1.shouqiev.com/gofunplatform/files/20220819/qraJTQsjKz.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-col group_6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exchangeCode),
      expression: "exchangeCode"
    }],
    staticClass: "text-wrapper_1 text_5",
    attrs: {
      "type": "text",
      "placeholder": "请输入兑换码"
    },
    domProps: {
      "value": (_vm.exchangeCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exchangeCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-col items-center button",
    on: {
      "click": _vm.exchange
    }
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("立即兑换")])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ab78aba0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ab78aba0","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/saleCar/exchangeCode/exchangeCouponCode.vue
// module id = 285
// module chunks = 320 321